import { NgTemplateOutlet } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  HostListener,
  input,
  InputSignal,
  output,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { Cell } from '../../models/cell';
import { Row } from '../../models/row';
import { CellValueComponent } from '../cell-value/cell-value.component';

@Component({
  selector: 'pozi-table-cell',
  imports: [NgTemplateOutlet, RouterLink, CellValueComponent],
  templateUrl: './table-cell.component.html',
  styleUrl: './table-cell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellComponent {
  @HostListener('click') clicked() {
    this.cellClicked.emit(this.cell());
  }

  cell: InputSignal<Cell> = input.required<Cell>();
  row: InputSignal<Row> = input.required<Row>();
  rowId: InputSignal<number> = input.required<number>();
  readonly customCellTemplate = input<null | TemplateRef<{
    row: Row;
    rowId: number;
    cell: Cell;
  }>>(null, { alias: 'cellTemplate' });
  progressBarTextMaxLength = input<number | undefined>();

  cellClicked = output<Cell>();

  readonly defaultCellTemplate = viewChild.required<
    TemplateRef<{ row: Row; rowId: number; cell: Cell }>
  >('defaultCellTemplate');
  readonly cellTemplate = computed(() =>
    this.customCellTemplate() !== null
      ? this.customCellTemplate()
      : this.defaultCellTemplate()
  );
  readonly route = computed<string | null>(() => this.cell()?.route || null);
}
